/**
 * 分享页面拦截器服务
 */
export interface SharePageInterceptorService {
    /**
     * 注册 axios 拦截器
     */
    registerAxiosInterceptor(): void;
}

export const SharePageInterceptorService = Symbol('SharePageInterceptorService');
